import { render, staticRenderFns } from "./LoginsByType.vue?vue&type=template&id=13d5a25c&scoped=true"
import script from "./LoginsByType.vue?vue&type=script&lang=js"
export * from "./LoginsByType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d5a25c",
  null
  
)

export default component.exports